import { render, staticRenderFns } from "./StockKlineDay.vue?vue&type=template&id=5f2787d1"
import script from "./StockKlineDay.vue?vue&type=script&lang=js"
export * from "./StockKlineDay.vue?vue&type=script&lang=js"
import style0 from "./StockKlineDay.vue?vue&type=style&index=0&id=5f2787d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports